import { viewWidth } from '~/utils/viewWidth';

export const clamp = (min: number, max: number, vw: number = 1440) => {
  const isNegative = min < 0 || max < 0;

  const value = `clamp(${Math.abs(min)}px, ${viewWidth(max, vw)}vw ,${Math.abs(max)}px)`;

  return isNegative ? `calc(${value} * -1)` : value;
};
